import React from 'react';
import { Router, Route, Routes, BrowserRouter } from 'react-router-dom';

import { PrivateRoute } from '../routes/PrivateRoute';
import { FundRaiserPage } from '../pages/fundraiser/page';
import { DonateFundraiser, DonateCampaign } from '../pages/donate';
import { EditFundraiser, FundRaiserList, CreateFundraiser } from '../pages/fundraiser';
import { ForgotPassword, ResetPassword, LoginSignupScreen } from '../pages/loginSignup';
import { FundraisingQAs } from '../pages/fundraisingQAs';

import {
    CookiePolicy,
    PrivacyPolicy,
    Campaign,
    ThankYou,
    Home,
    PageNotFound,
    TransactionFailed,
    Profile,
    EventsList,
    EventDetailsPage
} from '../pages';
import LoadingOverlay from 'react-loading-overlay';
import { useSelector } from 'react-redux';
import AboutUs from '../pages/aboutUs';
import { WEB_URL } from '../api/URLs';


const WebRoutes = () => {
    const pageLoading = useSelector(state => state.donation.redux_loader);
    return (
        <BrowserRouter>
            {/* <div className="root-box"> */}
            <LoadingOverlay active={pageLoading} spinner text='Please wait...'>
                <Routes>
                    {/* PUBLIC ROUTES */}
                    <Route path={WEB_URL.HOME} element={<Home />} />

                    <Route path={WEB_URL.EVENTS} element={<EventsList />} />
                    <Route path={WEB_URL.EVENT_DETAILS} element={<EventDetailsPage />} />
                    <Route path={WEB_URL.LOGIN} element={<LoginSignupScreen />} />
                    <Route path={WEB_URL.PAGE_NOT_FOUND} element={<PageNotFound />} />
                    <Route path={WEB_URL.COOKIE_POLICY} element={<CookiePolicy />} />
                    <Route path={WEB_URL.FUNDRAISER_LISTING} element={<FundRaiserList />} />
                    <Route path={WEB_URL.FUNDRAISER_DETAILS()} element={<FundRaiserPage />} />
                    <Route path={WEB_URL.FUNDRAISER_DETAILS_BY_ID()} element={<FundRaiserPage />} />
                    <Route path={WEB_URL.CAMPAIGN_DETAILS()} element={<Campaign />} />
                    <Route path={WEB_URL.PRIVACY_POLICY} element={<PrivacyPolicy />} />
                    <Route path={WEB_URL.PASSWORD_RESET()} element={<ResetPassword />} />
                    <Route path={WEB_URL.FORGOT_PASSWORD} element={<ForgotPassword />} />
                    <Route path={WEB_URL.THANK_YOU()} element={<ThankYou />} />
                    <Route path={WEB_URL.CAMPAIGN_CHECKOUT()} element={<DonateCampaign />} />
                    <Route path={WEB_URL.FUNDRAISER_CHECKOUT()} element={<DonateFundraiser />} />
                    <Route path={WEB_URL.FAQS} element={<FundraisingQAs />} />
                    <Route path={WEB_URL.ABOUT_US} element={<AboutUs />} />
                    <Route path={WEB_URL.DONATION_FAILED} element={<TransactionFailed />} />

                    {/* PRIVATE ROUTES */}
                    <Route element={<PrivateRoute />}>
                    <Route path={WEB_URL.PROFILE()} element={<Profile/>} />
                    <Route path={WEB_URL.CREATE_FUNDRAISER} element={<CreateFundraiser/>} />
                    <Route path={WEB_URL.UPDATE_FUNDRAISER()} element={<EditFundraiser/>} />
                    </Route>

                    {/* 404 page */}
                    <Route path="*" element={<PageNotFound/>} />
                </Routes>
            </LoadingOverlay>
            {/* </div> */}
        </BrowserRouter>
    )
}

export default WebRoutes;